import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@clerk/react-router';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

interface KnockAuth {
  token: string;
  userId: string;
}

export function useKnockToken() {
  const { getToken, isSignedIn } = useAuth();

  return useQuery<KnockAuth>({
    queryKey: ['knock-token'],
    queryFn: async () => {
      const clerkToken = await getToken();
      if (!clerkToken) throw new Error('No Clerk token available');
      const res = await fetch(`${API_BASE_URL}/api/knock-token`, {
        headers: { Authorization: `Bearer ${clerkToken}` },
      });
      if (!res.ok) throw new Error('Failed to fetch Knock token');
      const data = await res.json();
      return { token: data.token, userId: data.userId };
    },
    enabled: !!isSignedIn,
    staleTime: 10 * 60 * 1000, // 10 minutes
    retry: 2,
  });
}
